import * as React from 'react';
import UserExplorerTable from '../../components/UserExplorerTable/UserExplorerTable';

import ExplorerData from '../../interfaces/ExplorerData';
import ExplorerCurrentCategory from '../../interfaces/ExplorerCurrentCategory';

interface Props {
  userExplorerData: ExplorerData;
  filteredCategory: ExplorerCurrentCategory;
}

const GetUserExplorerRender = (props: Props) => {
  if (undefined !== props.userExplorerData.data.event && props.userExplorerData.data.event.length) {
    return (
      <UserExplorerTable
        userExplorer={props.userExplorerData.data.event}
        filteredCategory={props.filteredCategory}
      />
    );
  } else {
    return null;
  }
};

export default GetUserExplorerRender;
